export function getAdminRoleLabel(role) {
  switch (role) {
    case 'super_admin': return 'Super Admin';
    case 'finance_admin': return 'Finance Admin';
    case 'credit_control': return 'Credit Control';
    case 'underwriting': return 'Underwriting';
    case 'admin': return 'Administrator';
    default: return 'User';
  }
}
